import { render, staticRenderFns } from "./AdmissionConsultText.vue?vue&type=template&id=08a56472&scoped=true"
import script from "./AdmissionConsultText.vue?vue&type=script&lang=js"
export * from "./AdmissionConsultText.vue?vue&type=script&lang=js"
import style0 from "./AdmissionConsultText.vue?vue&type=style&index=0&id=08a56472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a56472",
  null
  
)

export default component.exports